const SwiperSlide = (props) => {
  const { children, className, ...rest } = props;

  return (
    <swiper-slide class={className} {...rest}>
      {children}
    </swiper-slide>
  );
};

export default SwiperSlide;
